import * as firebase from 'firebase';
import Config from './Configs';

const settings = { timestampsInSnapshots: true };

firebase.initializeApp(Config.FCM_CONFIG);

firebase.firestore().settings(settings);

export default firebase;


// import * as firebase from 'firebase/app';
// import "firebase/messaging";
// import { ReducersTypes } from './';
// import { CommonReducerAction } from './../Actions/commonAction';

// var config = {
//     apiKey: "AIzaSyCTvrSX_2-J2K8U0X1cRdgqtU1X1Uj4Hqw",
//     authDomain: "sumhr-24e5f.firebaseapp.com",
//     databaseURL: "https://sumhr-24e5f.firebaseio.com",
//     projectId: "sumhr-24e5f",
//     storageBucket: "sumhr-24e5f.appspot.com",
//     messagingSenderId: "880734449671"
// }

// var firebaseConfig = firebase.initializeApp(config);
// // firebase.messaging().deleteToken("dhmXBtadkBY:APA91bGmx0wfDL5dXYoZCDqTY_hAqBaNfStm4pGuh7S9JDtRxFUCbeWhaxYLHejmaiPz0i8WQL8VzwlVbKEjVxuBpw7tM7URaaCa3SdD1rYv_vQ-qNjWbievdl-DFjldlE8276lq2en3");
// let messaging = firebaseConfig.messaging()

// navigator.serviceWorker
//     .register('/firebase-messaging-sw.js')
//     .then((registration) => {
//         messaging = firebaseConfig.messaging().useServiceWorker(registration);
//     });

// function messagingFun() {
//     messaging.onMessage(handleBgCb)

//     messaging
//         .requestPermission()
//         .then(() => {
//             // console.log("Notification permission granted.");

//             messaging
//                 .getToken()
//                 .then(devicetokenid => {

//                     if (devicetokenid) {
//                         // console.log("Token generated is ", devicetokenid);
//                     } else {
//                         // Show permission request.
//                         // console.log("No Instance ID token available. Request permission to generate one.");
//                     }
//                 })
//                 .catch(err => {
//                     // console.log("An error occurred while retrieving token. ", err);
//                 });
//         })
//         .catch(err => {
//             // console.log("Unable to get permission to notify.", err);
//         });
// }

// // messagingFun();

// function handleBgCb(payload) {
//     CommonReducerAction(ReducersTypes.FCM, payload)
//     // // console.log(payload);
//     // const payloadMsg = JSON.stringify(payload);
//     // // console.log("payloadMsg" + payloadMsg)
//     // // console.log("Title" + payload.notification.title)
// }

// export default firebaseConfig;
